import React, { useState } from 'react'
import './style.css'
import { useCountContext } from "../../utils/global";


function Index({ id }) {
  const [state, dispatch] = useCountContext();
  return (
    <div
      id={id}
      className='tip'
      style={{ visibility: id === `tip${state.name}` ? 'visible' : 'hidden', display: state.tipDisplay }}
    >
      {id === 'tiptrace' ? <div>
        <p className='techUsed'>Express, React, Firebase, REST API, Node.js</p>
        <p>
          A contact tracing simulation to gain a visual appreciation of the complex work our contract tracers face every day.
        <br />
          <br />
        Different lines at differet connection levels can be toggled on and off, hovering on a node of concern with highlight the immediate connections surrounding the node
        <br />
          <br />
        A contact tracer can tag a person as a confirmed case by typing their phone number (1-2000) or by clicking on one of the small circles
        </p></div> :
        id === 'tipsort' ? <div>
          <p className='techUsed'>React, Firebase, Node.js</p>
          <p>
            A visualization of 4 common sorting algorithms:
        <br />
            <br />
        Merge sort
        <br />
            <br />Heap sort
        <br />
            <br />Quick sort
        <br />
            <br />Radix sort
        </p></div> :
          id === 'tipenigma' ? <div>
            <p className='techUsed'>Express, React, AWS DynamoDB, Firebase Hosting, REST API, Node.js</p>
            <p>
              A digital recreation of the infamous German encryption machine
        <br />
              <br />
         Remember the code at the start of typing then type normally
        <br />
              <br />
         To decrypt a message, readjust the dials to the original code then type in the encrypted message
         <br />
              <br />
         Try to decrypt a message from the message board!
        </p></div> :
            <div>
              <p className='techUsed'>JQuery, GH-Pages, REST API, Bootstrap</p>
              <p>A card library and deck builder for Magic the Gathering
        <br />
                <br />
        Search and filter algrithms built from scratch pre ES6
        <br />
                <br />
         Users can filter cards based on their color and search for cards based on certain key words
         <br />
                <br />
         Advanced options allow users to filter cards based on their color, cost, type, rarity and set name
        </p></div>
      }


    </div>
  )
}

export default Index
